var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('v-overlay',{attrs:{"opacity":0.7,"z-index":"99999"}},[_c('v-progress-circular',{staticClass:"circle",attrs:{"size":50,"indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }